import { PORT, URL } from 'const';
const punycode = require('punycode');

export const getSubdomainUrl = (code: string, isProduction: boolean) =>
  isProduction
    ? `https://${punycode.toASCII(code)}.${URL}/`
    : `http://${punycode.toASCII(code)}.localhost:${PORT}`;
